import { render, staticRenderFns } from "./AccountNav.vue?vue&type=template&id=b9b7c8f2&scoped=true&"
import script from "./AccountNav.vue?vue&type=script&lang=js&"
export * from "./AccountNav.vue?vue&type=script&lang=js&"
import style0 from "./AccountNav.vue?vue&type=style&index=0&id=b9b7c8f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b7c8f2",
  null
  
)

export default component.exports